module.exports = __webpack_public_path__ + "img/ch7.46363293.png";